import { createContext } from "react";

export type Theme = "dark" | "light";

export interface ThemeContextValue {
  theme: Theme;
  toggleTheme: () => void;
}

/**
 * Theme context. The provider (app/providers/ThemeProvider) owns the state and
 * persistence; components read it via the `useTheme` hook. Undefined default
 * lets the hook throw a clear error if used outside the provider.
 */
export const ThemeContext = createContext<ThemeContextValue | undefined>(undefined);

export const THEME_STORAGE_KEY = "iog-operating-system.theme";
